import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  init: false,
  info: null,
  lot: null,
  fund: null,
  data: {
    paymentMethod: null,
    userPaymentId: null
  },
  request: {
    error: null,
    email: null,
    message: null
  },
  payments: {},
  currency: {}
}

const getInfoActions = generateActions('payment/GET_INFO')
export const requestInfoActions = generateActions('payment/REQUEST_INFO')
const sendActions = generateActions('payment/SEND_INFO')

export const setPaymentData = createAction('payment/SEND_INFO', (field, value) => ({ field, value }))

export const getInfo = createAction(
  API_CONST,
  id => ({
    url: `payments/${id}`,
    actions: getInfoActions
  })
)

export const requestPaymentInfo = createAction(
  API_CONST,
  id => ({
    url: `/auth/info/lots/${id}/requestPayment`,
    actions: requestInfoActions
  })
)

export const sendPayment = createAction(
  API_CONST,
  (id, data) => ({
    method: 'POST',
    redirectWindow: true,
    params: data,
    url: `/auth/info/lots/${id}/requestPayment`,
    actions: sendActions
  })
)

export default handleActions({
  [setPaymentData]: (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      [payload.field]: payload.value
    }
  }),
  [getInfoActions[0]]: (state, { payload }) => ({ ...initial }),
  [getInfoActions[1]]: (state, { payload }) => {
    const lot = reformatLot(payload.lot)
    const fund = lot.fund
    delete payload.lot

    return ({
      ...state,
      init: true,
      info: payload,
      lot,
      fund
    })
  },
  [getInfoActions[2]]: state => ({ ...state, init: true }),
  [requestInfoActions[0]]: state => ({ ...state, request: initial.request }),
  [requestInfoActions[1]]: (state, { payload }) => ({
    ...state,
    currency: payload.currency,
    payments: payload.payments
  }),
  [sendActions[1]]: (state, { payload }) => ({
    ...state,
    request: {
      ...state.request,
      message: payload.message
    }
  }),
  [sendActions[2]]: (state, { payload }) => ({
    ...state,
    request: {
      ...state.request,
      error: payload.message.response.data.error
    }
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/payment/index.js